import { FETCH_CTV_REQUEST, FETCH_CTV_DATA, FETCH_CTV_ERROR, RESET_CTV_DATA } from './ctvTypes';

const initialState = {
  loading: false,
  error: '',
  overall: [],
  creative: [],
  campaign: [],
  supply: [],
  exchange: []
};

const ctvReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CTV_REQUEST:
      return { ...state, loading: true, error: '' };
    case FETCH_CTV_DATA:
      return {
        ...state,
        loading: false,
        error: '',
        overall: action.payload.overall,
        creative: action.payload.creative,
        campaign: action.payload.campaign,
        supply: action.payload.supply,
        exchange: action.payload.exchange
      };
    case FETCH_CTV_ERROR:
      return { ...initialState, error: action.payload };
    case RESET_CTV_DATA:
      return { ...initialState };
    default:
      return state;
  }
};

export default ctvReducer;
